<template>
  <div>
      <div>
       
      <b-overlay :show="status && status.type === 'removed'" opacity="0.75" blur="0">
            <b-row class="bg-light mb-2" v-if="this.existingOrderQuantity > 0 && !this.adding"><p class="ml-3 mb-0 text-danger">{{this.existingOrderQuantity}} <span class="text-danger" v-if="this.existingOrderQuantity === 1 && !this.adding">copy</span><span v-else class="text-danger">copies</span> already on order.</p></b-row>
          <b-row>
              <b-col sm="6">
                  <p class="mb-0"><strong>{{ artist(item) }}</strong></p>
                  <p class="mb-0"><strong>{{ title(item) }}</strong></p>
                  <p class="mb-0" v-if="item.release.label">{{ item.release.label.name }} {{ item.release.label.catalogNo }}</p>
                  <p class="mb-0">{{ format(item.release.media) }}</p>
                  <p class="mb-0"><em>{{ pressing(item).join(', ') }}</em></p>
                  <p class="mb-0"><em>{{ notes(item).join(', ') }}</em></p>
              </b-col>

              <b-col sm="6">
                  <b-row>
                      <b-col sm="5">SKU</b-col>
                      <b-col>{{ item.itemId }}</b-col>
                  </b-row>
                  <div v-for="(c, index) in conditions(item.listing)" v-bind:key="'condition-' + index">
                      <b-row>
                          <b-col sm="5"><span>{{ c.subject }} Grade</span></b-col>
                          <b-col class="ml-auto">{{ c.grade }}</b-col>
                      </b-row>

                      <b-row v-if="c.notes">
                          <b-col>
                              <em>{{ c.notes }}</em>
                          </b-col>
                      </b-row>
                  </div>

                  <b-row>
                      <b-col sm="5">
                          <span>Price</span>
                      </b-col>

                      <b-col class="ml-auto">${{ item.listing.price }}</b-col>
                  </b-row>

                  <b-row>
                      <b-col class="d-flex align-items-center" sm="5">
                          <span>Order Qty</span>
                      </b-col>
                     
                      <b-col class="ml-auto"> 
                        <b-form-input class="quantity-input" size="sm" v-model="quantity" type="number" :max='this.maxQuantity' min=1 :formatter="maxQtyFormatter" v-if="this.maxQuantity > 1"></b-form-input><span v-else>{{this.quantity}}</span>
                      </b-col>
                  </b-row>

                  <b-row v-if="this.maxQuantity > 1">
                      <b-col sm="5">
                          <span>Inventory Qty</span>
                      </b-col>

                      <b-col class="ml-auto">{{ item.listing.count }}</b-col>
                    </b-row>

                  <b-row>
                      <b-col sm="5">
                          <span>Location</span>
                      </b-col>

                      <b-col class="ml-auto">{{ item.listing.location ? item.listing.location.toUpperCase() : '' }}</b-col>
                  </b-row>
                  <b-row class="mt-2">
                      <b-button class="ml-3" sm v-if="this.existingOrderQuantity > 0 && !this.adding" @click="this.addItem" variant="warning" :disabled="this.disabled"><span v-if="adding" class="text-white"><b-spinner small variant='light' class="mr-1"></b-spinner>Updating...</span><span class="text-white" v-else>Update order</span></b-button>
                      <b-button class="ml-3" sm v-else variant="success" @click="this.addItem" :disabled="this.disabled"><span v-if="adding" class="text-white"><b-spinner small variant='light' class="mr-1"></b-spinner>Adding...</span><span v-else class="text-light">Add to order</span></b-button>
                  </b-row>
              </b-col>
          </b-row>

          <template #overlay>
              <div class="text-center" v-if="status.type === 'removed'">
                  <h6 class="mb-0">Removed {{ moment(status.date).format('M/D/YYYY h:mma') }} by {{ status.username }}</h6>
                  <em v-if="status.reason">{{ status.reason }}</em>
                  <p>{{ status.stockAffected ? 'Stock changed' : 'Stock did not change' }}</p>
              </div>
          </template>
      </b-overlay>
      </div>
  </div>
</template>

<script>
  import OrderItemMixin from "../../builders/orderItem";
  import inventoryApi from "../../api/inventory";
  import ordersApi from "../../api/orders";

  export default {
      name: "EditOrderItem",
      props: [ 'item', 'status', 'existingOrderQuantity', 'orderItems', 'orderId', 'editing' ],
      mixins: [ OrderItemMixin, inventoryApi, ordersApi ],
      data() {
          return {
              quantity: 1,
              maxQuantity: 1,
              adding: false,
          }
      },
      async created() {
          this.adding = false;

          if (this.existingOrderQuantity > 0 && !this.adding) {
            this.quantity = parseInt(this.existingOrderQuantity);
          }
          if (this.item.listing.count > 1 || (this.existingOrderQuantity > 0 && !this.adding)) {
            this.maxQuantity = parseInt(this.item.listing.count) + parseInt(this.existingOrderQuantity);
          }
      },
      methods: {
        maxQtyFormatter(value) {
            if (value > this.maxQuantity) return this.maxQuantity;
            return value;
          },
        async addItem() {
            this.$emit('toggleEditing')
            this.adding = true;
            // const updatedItems = await this.addOrderItem(this.orderId, this.item.itemId, this.item.listing._id, this.quantity);
            // const updatedItem = updatedItems.find(item => item.details.listing._id === this.item.listing._id);
            // this.$emit('addOrderItem', updatedItem);
            try {
                const updatedItems = await this.addOrderItem(this.orderId, this.item.itemId, this.item.listing._id, this.quantity);
                const updatedItem = updatedItems.find(item => item.details.listing._id === this.item.listing._id);
                this.$emit('addOrderItem', updatedItem);
            } catch (error) {
                this.adding = false;
                // Handle the error here
                console.error('Error adding order item:', error);
                alert(error.message);
            }
        }
      },
      computed: {
        disabled() {
            return parseInt(this.quantity) < 1 || this.quantity === '' || this.adding || this.editing
        }
      }
  }
</script>

<style scoped>
  span {
      color: grey;
  }

  .quantity-input {
    max-width: 90px;
  }
</style>